<template>
  <div class="foot">
    <div class="footTop">
      <div class="contentWidth clearfix">
        <div class="item">
          <p class="title">扫码关注董妈咪</p>
          <img src="@/assets/images/erweima.png" width="154" height="154" />
        </div>
         <div class="item">
          <!-- <p class="title">招募信息填写</p>
          <table class="join">
            <tr>
              <td>姓名</td>
              <td class="inputWrap">
                <input v-validate="'required|name'" :class="{'is-danger': errors.has('name') }" v-model="name" type="" name="name" placeholder="请输入姓名">
                <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
              </td>
            </tr>
            <tr>
              <td>手机号码</td>
              <td class="inputWrap">
                <input v-validate="'required|mobile'" :class="{'is-danger': errors.has('phone') }" v-model="phone" type="" name="phone" placeholder="请输入手机号码">
                 <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
              </td>
            </tr>
            <tr>
              <td>合作类型</td>
              <td class="inputWrap">
                <select v-model="type" v-validate="'required|type'" :class="{'is-danger': errors.has('type') }" name="type">
                  <option value="">请选择</option>
                  <option value="招募门店">招募门店</option>
                  <option value="县级代理">县级代理</option>
                  <option value="合伙人">合伙人</option>
                </select>
                 <span v-show="errors.has('type')" class="help is-danger">{{ errors.first('type') }}</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <a class="submitBtn" href="javascript:;" v-on:click="submitInfo">提交</a>
              </td>
            </tr>
          </table> -->
        </div>
        <div class="item">
          <p class="title">招商信息</p>
          <table class="business">
            <tr>
              <td>
                <img src="@/assets/images/tel.png" width="24"/>
              </td>
              <td>
                029-8758 1996
              </td>
            </tr>
           <!--  <tr>
              <td>
                 <img src="@/assets/images/sinaweibo.png" width="24"/>
              </td>
              <td>
                新浪微博
              </td>
            </tr> -->
            <tr>
              <td>
                <img src="@/assets/images/address.png" width="20"/>
              </td>
              <td>
                陕西省西安市经济技术开发区凤城八路西北国金C座2207室
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="footBottom">
      ©西安羊羊村落乳业集团有限公司 <a href="https://beian.miit.gov.cn" target="_blank">陕ICP备17015710号-2</a>
    </div>
  </div>
</template>

<script>
import api from '../config/api'

import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'
import cn from 'vee-validate/dist/locale/zh_CN'

Validator.localize('cn', cn)

const dictionary = {
  cn: {
    messages: {
      required: (field) => '请输入' + field
    },
    attributes: {
      type: '合作类型',
      name: '姓名',
      phone: '手机号码'
    }
  }
}

Validator.localize(dictionary)

const config = {
  events: 'blur'
}

Vue.use(VeeValidate, config)

export default {
  name: 'foot',
  data () {
    return {
      name: '',
      phone: '',
      type: '',
      submitStatus: false
    }
  },
  methods: {
    submitInfo () {
      if (this.submitStatus === true) {
        return
      }
      this.$validator.validateAll().then((result) => {
        if (result === true) {
          this.submitStatus = true
          var params = {
            'name': this.name,
            'telephone': this.phone,
            'type': this.type
          }
          api.addRecruiter(params)
            .then(res => {
              this.submitStatus = false
              if (res.code === 0) {
                this.name = ''
                this.phone = ''
                this.type = ''
                this.$emit('tipsShow', '提交成功！')
              } else {
                this.$emit('tipsShow', '提交失败，请重新填写一遍吧~')
              }
            })
        }
      })
    }
  },
  created () {
    Validator.extend('name', {
      getMessage: field => '请输入正确的姓名',
      validate: value => /^[\u4E00-\u9FA5]{1,5}$/.test(value)
    })
    Validator.extend('mobile', {
      getMessage: field => '请输入正确的手机号码',
      validate: value => value.length === 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/.test(value)
    })
    Validator.extend('type', {
      getMessage: field => '请选择合作类型',
      validate: value => value !== ''
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.foot{
  font-size: 18px;
  color: #fff;
  .footTop{
    padding: 46px 0;
    height: auto;
    background-color: #2e3640;
    .item{
      float: left;
      margin-left: 130px;
      &:first-child{margin-left: 50px;}
      &:last-child{
        .title {text-align: left;}
      }
      .title{
        text-align: center;
        margin-bottom: 24px;
      }
      .join{
        border-collapse: collapse;
        font-size: 16px;
        td{
          &:first-child{
            text-align:center;text-align:justify;text-justify:distribute-all-lines;text-align-last:justify
          };
          padding-bottom: 22px;
        }
        .inputWrap{
          position: relative;
          padding-left: 24px;
          span{position: absolute;font-size: 14px;color: #f95374;left:24px;top:36px;}
        }
        input,select{
          font-family: "microsoft yahei";
          height: 36px;
          width:211px;
          padding: 0 12px;
          border-radius: 3px;
          border: none;
          outline: none;
          font-size: 16px;
          color: #999;
          outline: none;
          background-color: #fff;
        }
        select{
          width: 235px;
          border: solid 1px #000;
          appearance:none;
          -moz-appearance:none;
          -webkit-appearance:none;
           padding-right: 14px;
           background:#fff url(../assets/images/ic_xiala.png) no-repeat scroll 213px center;
           background-size: 8px;
        }
        select::-ms-expand { display: none; }
        .submitBtn{
          display: block;
          color: #fff;
          background-color: #f95374;
          font-size: 16px;
          padding: 9px 0px;
          width: 233px;
          text-align: center;
          border-radius: 4px;
          margin-left: 25px;
        }
      }
      .business{
        border-collapse: collapse;
        padding-top: 3px;
        img{
          display: block;
        }
        width: 273px;
        font-size: 16px;
        td{
          &:first-child{padding-right:10px;};
          padding-bottom:29px;
        }
      }
    }
  }
  .footBottom{
    clear:both;
    font-size: 14px;
    text-align: center;
    line-height: 50px;
    background-color: #262e38;
    a {
      color: #39f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue